import { render, staticRenderFns } from "./ProjectBuildingRatings.vue?vue&type=template&id=e98e605e&scoped=true&"
import script from "./ProjectBuildingRatings.vue?vue&type=script&lang=js&"
export * from "./ProjectBuildingRatings.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBuildingRatings.vue?vue&type=style&index=0&id=e98e605e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98e605e",
  null
  
)

export default component.exports